function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.133 26.12l-7.137 6.775c-.27.268-.408.464-.408 1.018v18.991c0 .223.183.405.408.405h7.372a.406.406 0 00.406-.405V26.29c.001-.224-.175-.633-.64-.17M28.572 34.947l-7.138 6.775c-.269.268-.407.465-.407 1.018v10.164c0 .223.183.404.407.404h7.372a.405.405 0 00.407-.404V35.117c.001-.225-.176-.634-.64-.17"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.317 17.748a.219.219 0 00-.13-.058l-.04.002-.06.002-5.464 1.232-.1.01a.207.207 0 00-.107.35l.062.061 1.248 1.245-12.383 12.36-5.719-5.709a.164.164 0 00-.233 0l-1.55 1.55h-.003l-9.168 9.148a.167.167 0 000 .233l1.554 1.551a.162.162 0 00.23 0l9.055-9.034 4.15 4.141a.06.06 0 00.013.021l1.553 1.546a.162.162 0 00.232 0l14.054-14.025 1.312 1.307a.205.205 0 00.35-.134l.002-.019 1.2-5.567.003-.06a.202.202 0 00-.06-.153"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.893 36.136l-3.453 3.475a.167.167 0 01-.223-.008l-3.129-3.183c-.572-.57-.696-.108-.696.116v16.366c0 .224.181.405.404.405h7.375a.407.407 0 00.406-.405V36.264c0-.223-.176-.634-.684-.128"
}));

var SvgOds08 = function SvgOds08(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 71 71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOds08, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ods08.ed46ddf5.svg";
export { ForwardRef as ReactComponent };